import { useDispatch, useSelector } from "react-redux"
import { changeStatus, onFetchCartolas, onFetchTotalRows, selectCartolaState } from "../redux/slices/cartolaSlice"
import { ApiStatus } from "../types/api/status"
import { CartolaAPI } from "../apis/CartolaAPI"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"

export const useCartolaStore = () => {
    const dispatch = useDispatch()
    const { cartolas, cartolaSelected, status, totalRows } = useSelector(selectCartolaState)

    const getCartolas = async (data?: object) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await CartolaAPI.get(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail, total } = response.data
            dispatch(onFetchCartolas(detail || []))
            dispatch(onFetchTotalRows(total || 0))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const clearCartolas = () => {
        dispatch(onFetchCartolas([]))
        dispatch(onFetchTotalRows(0))
    }

    const getCartolaExcel = async (data: object) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await CartolaAPI.getExcel(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getCartolaPDF = async (data: object) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await CartolaAPI.getPDF(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    return {
        cartolas,
        cartolaSelected,
        status,
        totalRows,
        getCartolas,
        clearCartolas,
        getCartolaExcel,
        getCartolaPDF
    }
}